module.exports = __webpack_public_path__ + "img/bg-blue2.1066907f.svg";